import { render, staticRenderFns } from "./BasicAllList.vue?vue&type=template&id=70b532f7&"
import script from "./BasicAllList.vue?vue&type=script&lang=js&"
export * from "./BasicAllList.vue?vue&type=script&lang=js&"
import style0 from "./BasicAllList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports